<template>
<div>
  <ModalContent
    @close="$emit('close', false)"
    background-color="none"
  >
    <template v-slot:header>
    <div class="row">
      <div class="col-xs-2">
        <button
          @click="closeModal"
          class="btn btn-fill btn-danger btn-icon navegation-button"
        >
          <i class="ti-close"></i>
        </button>
      </div>
    </div>
    </template>
    <template v-slot:body>
    <div
      class="row"
      style="display: flex; height: 60vh;"
    >
      <div class="col-xs-1 self-center">
        <button
          @click="currentIndex = (((currentIndex - 1) + images.length) % images.length)"
          class="btn btn-fill btn-icon btn-primary btn-lg"
        ><i class="ti-angle-left"></i></button>
      </div>
      <div class="col-xs-10 text-center items-center justify-center">
        <a :href="currentImg" target="_blank">
          <img
            :src="currentImg"
            class="img-body"
          >
        </a>
      </div>
      <div class="col-xs-1 self-center">
        <button
          @click="currentIndex = ((currentIndex + 1) % images.length)"
          class="btn btn-fill btn-icon btn-primary btn-lg"
        ><i class=" ti-angle-right"></i></button>
      </div>
    </div>
    </template>
    <template v-slot:footer>
    <div style="display: flex; justify-content: center; align-items: center;">
      <img
        v-for="(src, index) in images"
        :key="index"
        :src="src"
        alt="1"
        :class="`image-footer ${currentIndex === index ? 'current-footer' : ''}`"
      >
    </div>
    </template>
  </ModalContent>
</div>
</template>

<script>
import ModalContent from './ModalContent'

export default {
  name: 'GalleryComponent',
  components: { ModalContent },
  props: {
    images: {
      default: () => []
    },
    index: {
      default: 0
    }
  },

  data () {
    return {
      currentIndex: 0
    }
  },

  watch: {
    index () {
      this.$nextTick(() => {
        this.currentIndex = this.index
      })
    }
  },

  computed: {
    currentImg: function () {
      return this.images[this.currentIndex]
    }
  },

  methods: {
    closeModal () {
      this.$emit('close')
    }
  }
}
</script>

<style scoped>
  .self-center {
    align-self: center;
  }

  .img-body {
    max-height: 95%;
    max-width: 100%;
  }

  .image-footer {
    margin: 0px 10px 0px 10px;
    max-height: 70px;
    max-width:
  }

  .current-footer {
    /*border: 1px solid white;*/
    box-shadow: white 0px 0px 10px 3px;
  }
</style>



// WEBPACK FOOTER //
// src/components/GalleryComponent.vue